(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../array', '../collection', '../lang', '../math', '../object', '../string', 'lodash/concat', 'lodash/drop', 'lodash/get', 'lodash/head', 'lodash/isSymbol', 'lodash/map', 'lodash/mapValues', 'lodash/omit'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../array'), require('../collection'), require('../lang'), require('../math'), require('../object'), require('../string'), require('lodash/concat'), require('lodash/drop'), require('lodash/get'), require('lodash/head'), require('lodash/isSymbol'), require('lodash/map'), require('lodash/mapValues'), require('lodash/omit'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.array, global.collection, global.lang, global.math, global.object, global.string, global.concat, global.drop, global.get, global.head, global.isSymbol, global.map, global.mapValues, global.omit);
    global.UsingWrapper = mod.exports;
  }
})(this, function (exports, _array, _collection, _lang, _math, _object, _string, _concat, _drop, _get, _head, _isSymbol, _map, _mapValues, _omit) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.UsingWrapper = undefined;

  var array = _interopRequireWildcard(_array);

  var collection = _interopRequireWildcard(_collection);

  var lang = _interopRequireWildcard(_lang);

  var math = _interopRequireWildcard(_math);

  var object = _interopRequireWildcard(_object);

  var string = _interopRequireWildcard(_string);

  var _concat2 = _interopRequireDefault(_concat);

  var _drop2 = _interopRequireDefault(_drop);

  var _get2 = _interopRequireDefault(_get);

  var _head2 = _interopRequireDefault(_head);

  var _isSymbol2 = _interopRequireDefault(_isSymbol);

  var _map2 = _interopRequireDefault(_map);

  var _mapValues2 = _interopRequireDefault(_mapValues);

  var _omit2 = _interopRequireDefault(_omit);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var UsingWrapper = function () {

    /**
     * This constructor should not be called directly.<br/>
     * Instances are created by calling {@link object.using}.
     * @param {...(Array|string)} paths The paths to use as arguments.
     * @see {@link object.using} for more information.
     * @since 0.1.12
     */
    function UsingWrapper() {
      _classCallCheck(this, UsingWrapper);

      for (var _len = arguments.length, paths = Array(_len), _key = 0; _key < _len; _key++) {
        paths[_key] = arguments[_key];
      }

      this._paths = paths;
    }

    /**
     * Argument placeholder.
     * @since 0.2.1
     */


    _createClass(UsingWrapper, [{
      key: '_call',
      value: function _call(fn, object, path, pArgs) {
        var callArgs = pArgs;
        var args = (0, _concat2.default)((0, _map2.default)(this._paths, function (usingPath) {
          if ((0, _isSymbol2.default)(usingPath)) {
            var arg = (0, _head2.default)(callArgs);
            callArgs = (0, _drop2.default)(callArgs);
            return arg;
          }
          return (0, _get2.default)(object, usingPath);
        }), callArgs);
        return fn.apply(undefined, [object, path].concat(_toConsumableArray(args)));
      }
    }]);

    return UsingWrapper;
  }();

  UsingWrapper.placeholder = Symbol.for('immutadot.using.placeholder');


  // Add namespaces functions to the UsingWrapper prototype
  [array, collection, _extends({}, (0, _omit2.default)(object, ['unset'])), lang, math, object, string].forEach(function (namespace) {
    return Object.assign(UsingWrapper.prototype, (0, _mapValues2.default)(namespace, function (fn) {
      return function (object, path) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        return this._call(fn, object, path, args); // eslint-disable-line no-invalid-this
      };
    }));
  });

  exports.UsingWrapper = UsingWrapper;
  exports.default = UsingWrapper;
});